import React from 'react';
import LocationFunction from './LocationFunction';
import { ApiWrapped } from './ApiWrapped';

export default function LocationFunctions({ token, dashboard, device, nodes }) {
  const sorted = nodes.slice(0);
  sorted.sort((a, b) => {
    let aa = dashboard.indexOf(a.deviceNodeUuid);
    let bb = dashboard.indexOf(a.deviceNodeUuid);
    if (aa === bb) {
      aa = a.name.toLowerCase();
      bb = b.name.toLowerCase();
      if (aa > bb) {
        return 1;
      } else {
        return -1;
      }
    }
    return aa - bb;
  });
  return (
    <ApiWrapped
      token={token}
      endpoint={`/devices/${device.deviceUuid}/device-nodes`}
      optional={[]}
      renderCallback={({ state: status }) => {
        return (
          <>
            {sorted.map((node) => (
              <LocationFunction
                key={node.deviceNodeUuid}
                token={token}
                device={device}
                node={node}
                liveStatus={status.data.find((n) => n.deviceNodeUuid === node.deviceNodeUuid)}
              />
            ))}
          </>
        );
      }}
    />
  );
}
